import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Switch, Route, Redirect } from 'react-router';
import { FormattedMessage } from 'react-intl';

import style from './Recognition.module.scss';

import { ROUTES } from 'routes/routes';
import RecognitionStore from 'stores/Recognition/RecognitionStore';
import ModalStore from 'stores/ModalStore';

import NavigationTabs from 'components/NavigationTabs/NavigationTabs';
import DatasetsPage from './Datasets/DatasetsPage';
import ModelsPage from './Models/ModelsPage';
import ClusterAgentsPage from './ClusterAgents/ClusterAgentsPage';
import TasksPage from './Tasks/TasksPage';
import DeploymentsPage from './Deployments/DeploymentsPage';
import Button from 'components/Button/Button';
import VideoPlayerModal from 'components/Modals/VideoPlayer/VideoPlayerModal';
import PinField from 'components/Form/Fields/Pin/PinField';

@observer
class RecognitionPage extends Component {
  render() {
    if (!RecognitionStore.isPinValid) {
      return <>{this._renderPin()}</>;
    }

    return <>{this._renderRecognition()}</>;
  }

  private _handlePinChange = (value: string[]) => {
    RecognitionStore.changePin(value);
  };

  private _renderPin = () => {
    const pin = RecognitionStore.pin;

    return (
      <main className={style.pin}>
        <div className={style.pinTitle}>
          <FormattedMessage id="page.recognition.pin.title" />
        </div>
        <div className={style.pinField}>
          <PinField
            value={pin}
            length={4}
            hasError={pin.length === 4}
            onChange={this._handlePinChange}
          />
        </div>
        <div className={style.pinText1}>
          <FormattedMessage id="page.recognition.pin.text1" />
        </div>
        <div className={style.pinText2}>
          <FormattedMessage id="page.recognition.pin.text2" />
        </div>
        <Button
          className={style.pinButton}
          onClick={this._handlePinButtonClick}
        >
          <FormattedMessage id="page.recognition.pin.button" />
        </Button>
      </main>
    );
  };

  private _renderRecognition = () => {
    return (
      <div className={style.content__tabs}>
        <NavigationTabs
          className={style.tabs}
          tabs={[
            { to: ROUTES.admin.datasets, title: 'title.datasets' },
            { to: ROUTES.admin.tasks, title: 'title.tasks' },
            { to: ROUTES.admin.models, title: 'title.models' },
            { to: ROUTES.admin.deployments, title: 'title.deployments' },
            { to: ROUTES.admin.agents, title: 'title.agents' },
          ]}
        />

        <Switch>
          <Route path={ROUTES.admin.datasets} component={DatasetsPage} exact />
          <Route path={ROUTES.admin.tasks} component={TasksPage} exact />
          <Route path={ROUTES.admin.models} component={ModelsPage} exact />
          <Route
            path={ROUTES.admin.deployments}
            component={DeploymentsPage}
            exact
          />
          <Route
            path={ROUTES.admin.agents}
            component={ClusterAgentsPage}
            exact
          />

          <Redirect to={ROUTES.admin.datasets} />
        </Switch>
      </div>
    );
  };

  private _handlePinButtonClick = () => {
    ModalStore.showModal(VideoPlayerModal, {
      titleId: 'page.recognition.pin.modal.title',
      src: '/assets/media/sionum-scan-and-pay.mp4',
    });
  };
}

export default RecognitionPage;
